import { Theme } from 'src/theme/theme'
import { Interpolation } from '@emotion/css'

const styles = {
  formCard: (theme: Theme): Interpolation => ({
    background: theme.colors.white,
    padding: '63px 15px 25px 15px',
    borderRadius: 10,
    position: 'absolute',
    top: '79%',
    left: '50%',
    transform: 'translateX(-50%)',
    zIndex: -1,
    '@media (max-width: 668px)': {
      position: 'relative',
      padding: 15,
      top: 0,
      left: 0,
      transform: 'none',
    },
  }),
  flex: {
    display: 'flex',
    justifyContent: 'space-around',
    width: 420,
    h6: {
      lineHeight: '36px',
    },
    '@media (max-width: 668px)': {
      display: 'block',
      width: 'auto',
      h6: {
        textAlign: 'center' as const,
      },
      span: {
        display: 'flex',
        margin: '0 auto',
      },
    },
  },
  purchaseButton: {
    position: 'absolute',
    top: '95%',
    left: '50%',
    transform: 'translateX(-50%)',
    margin: 0,
  } as Interpolation,
  editExpenseContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: 30,
    '@media (max-width: 668px)': {
      marginTop: 0,
    },
  },
  disabled: {
    display: 'flex',
    width: 66,
    justifyContent: 'space-between',
    alignItems: 'end',
  },
}

export default styles
